/**
 * @generated SignedSource<<47bf044c110890ade4ac5102b3dfa770>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateScheduleTemplatePeriodPayload",
            "kind": "LinkedField",
            "name": "updateScheduleTemplatePeriod",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfScheduleTemplatePeriod",
                    "kind": "LinkedField",
                    "name": "periodEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleTemplatePeriod",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleTemplatePeriodModalUpdateMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleTemplatePeriodModalUpdateMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1761d775d3ecb45c995fe56db50630bb",
            "id": null,
            "metadata": {},
            "name": "EditScheduleTemplatePeriodModalUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation EditScheduleTemplatePeriodModalUpdateMutation(\n  $model: UpdateScheduleTemplatePeriodRequestInput!\n) {\n  updateScheduleTemplatePeriod(model: $model) {\n    periodEdge {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "70b958515be1dfdf443abba709c0f656";
export default node;
